export default __webpack_public_path__ + "static/media/newProject.2ca0a9e9.png";